// Ponte de login do OAuth (services/auth): o servidor de autorização manda a pessoa para cá
// para entrar com a conta do ERP antes de autorizar um app (ex.: o conector do Claude).
const routes = [
    {
        name: 'autorizar_app',
        path: '/autorizar-app',
        component: () => import('../views/AutorizarApp'),
        meta: {
            public: true,
            fullScreen: true,
            temaClaro: true
        }
    }
]
export default routes
